import { mapState, mapMutations } from "vuex"

export default {
  computed: {
    ...mapState({
      BAND_IS_IN_DRAFT_FLOW: (state) => state.misc.draft.in_flow,
    }),
  },
  methods: {
    prepareAccountSwap: function (pk, email) {
      if (this.BAND_IS_IN_DRAFT_FLOW) {
        this.SET_SWAP_ACCOUNT({ pk, email })
        this.$router.push("/") // triggers save popup's guard
      } else {
        this.triggerAccountSwap(pk, email)
      }
    },
    triggerAccountSwap: function (pk, email) {
      const key = "backupSession_" + pk
      const value = window.localStorage.getItem(key)

      if (!value) this.$store.dispatch("login/REQUEST_ACCOUNT_SWAP", email)
      else {
        this.swapUser(value, pk)
          .then(() => {
            this.cleanCacheAll()
            window.location.href = window.location.origin + "/"
          })
          .catch(() => {
            window.localStorage.removeItem(key)
            this.$store.dispatch("login/REQUEST_ACCOUNT_SWAP", email)
          })
      }
    },
    swapUser: function (secret, pk) {
      return this.$axios.$post(`/auth/switch/${pk}/swap/`, { secret })
    },
    ...mapMutations({
      SET_SWAP_ACCOUNT: "misc/draft/SET_SWAP_ACCOUNT",
    }),
  },
}
